import classNames from "classnames";
import { FC, useMemo } from "react";

import { useLikeStore } from "@/stores";
import ChatIcon from "@/svgs/comment_alt_dots.svg";
import HeartIcon from "@/svgs/heart.svg";

import { useCreatePrivateChat } from "../../hooks";
import { useAdmireUser } from "../../hooks/use-admire-user.hook";
import { useUnadmireUser } from "../../hooks/use-unadmire-user.hook";

import styles from "./control-buttons.module.scss";
import { ControlButtonsProps } from "./control-buttons.types";

const ControlButtons: FC<ControlButtonsProps> = ({ id, admiredByMe, fixed, size }) => {
  const changedLikes = useLikeStore((state) => state.changedLikes);
  const changeUsersLike = useLikeStore((state) => state.actions.changeUsersLike);
  const isUserIdLikeChanged = useLikeStore((state) => state.actions.isUserIdChanged);

  const { mutate: admireUser } = useAdmireUser();
  const { mutate: unadmireUser } = useUnadmireUser();
  const { mutate: createPrivateChat, isPending: isCreatePrivateChatLoading } = useCreatePrivateChat();

  const liked = useMemo(
    () => (isUserIdLikeChanged(id) ? changedLikes[id] : admiredByMe),
    [id, admiredByMe, changedLikes[id], isUserIdLikeChanged]
  );

  const admire = () => {
    const isAdmired = isUserIdLikeChanged(id) ? changedLikes[id] : admiredByMe;

    if (isAdmired) {
      unadmireUser({ userId: id });
    } else {
      admireUser({ userId: id });
    }
    changeUsersLike({ userId: id, value: !isAdmired });
  };

  return (
    <div className={classNames(styles.controlButtons, fixed && styles.bottomFixed, styles[size])}>
      <button
        type="button"
        className={classNames(liked && styles.admired)}
        onClick={(e) => {
          e.stopPropagation();
          admire();
        }}
      >
        <HeartIcon />
      </button>
      <button
        type="button"
        disabled={isCreatePrivateChatLoading}
        onClick={(e) => {
          e.stopPropagation();
          createPrivateChat({ recipientId: id });
        }}
      >
        <ChatIcon />
      </button>
    </div>
  );
};

export { ControlButtons };
